import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { findAll } from "@/apis/companyStamp";
import { CompanyStampListItemDto } from "@/dto/CompanyStampDto";
import { findAllByProduct } from "@/apis/subscription";
import { findAllByTemplate } from "@/apis/template";
import { SubscriptionProductSelectionDto } from "@/dto/SubscriptionDto";
import { TemplateSelectionDto } from "@/dto/TemplatesDto";

/**
/**
 * 회사 검색 리스트 페이지 커스텀 훅
 * @returns 회사 검색 리스트 페이지 커스텀 훅
 */
export default function useList() {
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [count, setCount] = useState<number>(0);
  const [list, setList] = useState<CompanyStampListItemDto[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [subscriptionProductList, setSubscriptionProductList] = useState<
    SubscriptionProductSelectionDto[]
  >([]);
  const [templateList, setTemplateList] = useState<TemplateSelectionDto[]>([]);

  /**
   * 회사 검색 리스트 조회
   */
  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      const page = searchParams.get("page") || 1;
      const limit = searchParams.get("limit") || 10;
      const comNm = searchParams.get("comNm") || undefined;
      const admNm = searchParams.get("admNm") || undefined;
      const productId = searchParams.get("productId") || undefined;
      const templateId = searchParams.get("templateId") || undefined;
      const subscriptionStat =
        (searchParams.get("subscriptionStat") as
          | "PENDING"
          | "ACTIVE"
          | "CANCELED"
          | "EXPIRED"
          | undefined) || undefined;

      const res = await findAll({
        page: +page,
        limit: +limit,
        comNm,
        admNm,
        productId,
        templateId,
        subscriptionStat,
      });
      setCount(res.count);
      setPage(res.page);
      setLimit(res.limit);
      setList(res.list);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  }, [searchParams]);

  /**
   * 구독 상품 리스트 조회
   */
  const fetchSubscriptionProductList = useCallback(async () => {
    const res = await findAllByProduct();
    console.log(res);
    if (res.success) {
      setSubscriptionProductList(res.data);
    }
  }, []);

  /**
   * 템플릿 리스트 조회
   */
  const fetchTemplateList = useCallback(async () => {
    const res = await findAllByTemplate();
    if (res.success) {
      setTemplateList(res.data);
    }
  }, []);

  useEffect(() => {
    fetchData();
    fetchSubscriptionProductList();
    fetchTemplateList();
  }, [fetchData, fetchSubscriptionProductList, fetchTemplateList]);

  return {
    isLoading,
    count,
    page,
    limit,
    list,
    subscriptionProductList,
    templateList,
  };
}
